"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var vue_1 = __importDefault(require("vue"));
require("ngVue");
var UnsignedLessonsNotice_vue_1 = __importDefault(require("./UnsignedLessonsNotice.vue"));
var student_drives_controller_1 = __importDefault(require("./student-drives.controller"));
var student_drives_html_1 = __importDefault(require("./student-drives.html"));
function getStudent(UserService, $stateParams, UsersModel) {
    var currentUser = UserService.getCurrentUser();
    return UsersModel.getStudentByID(currentUser.id).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["UserService", "$stateParams", "UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.drives", {
        url: "/drives",
        abstract: true,
        template: "<section ui-view></section>",
        resolve: {
            student: getStudent,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.parent,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
    $stateProvider.state("drivecoach.student.drives.index", {
        url: "",
        template: student_drives_html_1.default,
        controller: student_drives_controller_1.default,
        controllerAs: "vm",
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
var book_drive_module_1 = __importDefault(require("./book-drive/book-drive.module"));
var student_drive_view_module_1 = __importDefault(require("./view/student-drive-view.module"));
var cancel_drive_module_1 = __importDefault(require("./cancel-drive/cancel-drive.module"));
var student_upcoming_drives_module_1 = __importDefault(require("./upcoming/student-upcoming-drives.module"));
var student_past_drives_module_1 = __importDefault(require("./student-past-drives/student-past-drives.module"));
var student_agenda_module_1 = __importDefault(require("./agenda/student-agenda.module"));
exports.default = angular_1.default
    .module("student.drives", [
    book_drive_module_1.default.name,
    student_drive_view_module_1.default.name,
    cancel_drive_module_1.default.name,
    student_upcoming_drives_module_1.default.name,
    student_past_drives_module_1.default.name,
    student_agenda_module_1.default.name,
])
    .directive("unsignedLessonsNotice", [
    "createVueComponent",
    function (createVueComponent) {
        return createVueComponent(vue_1.default.component("UnsignedLessonsNotice", UnsignedLessonsNotice_vue_1.default));
    },
])
    .config(config)
    .controller("StudentDrivesController", student_drives_controller_1.default);
